import { useIntl } from 'react-intl';

export const useNotFoundMessage = (intlMessage: string) => {
  const intl = useIntl().formatMessage;
  return intl(
    { id: 'commons.errors.notFound' },
    { content: intl({ id: intlMessage }) },
  );
};
